import { lazyLoad } from 'utils/loadable';

export const UserManagementLoadable = lazyLoad(
  () => import('./UserManagement'),
  module => module.UserManagement,
);
